import moment from 'moment';
import Vue from 'vue';
import api from './api';
import notify from '@/notify'


export const MODULE = 'partnerFinder';


// ----------------- API ENDPOINTS ---------------------------
export const API_GUEST_PARTNER_FINDER_PROFILE_POST = { method: 'POST', url: '/api/guest/partner-finder/profile' }
export const API_GUEST_PARTNER_FINDER_AVAILABLE_POST = { method: 'POST', url: '/api/guest/partner-finder/available' }
export const API_GUEST_PARTNER_FINDER_AVAILABLE_DELETE = {
  method: 'DELETE',
  url: '/api/guest/partner-finder/available',
}
export const API_GUEST_PARTNER_FINDER_APPLY_POST = { method: 'POST', url: '/api/guest/partner-finder/apply' }
export const API_GUEST_PARTNER_FINDER_APPLY_DELETE = { method: 'DELETE', url: '/api/guest/partner-finder/apply' }
export const API_GUEST_PARTNER_FINDER_ACCEPT_POST = { method: 'POST', url: '/api/guest/partner-finder/accept' }
export const API_GUEST_PARTNER_FINDER_ACCEPTED_DELETE = { method: 'DELETE', url: '/api/guest/partner-finder/accepted' }

// ----------------- ACTION TYPES ---------------------------
const saveProfile = 'saveProfile';
export const doSaveProfile = MODULE + '/' + saveProfile;
const appendToTable = 'appendToTable';
export const doAppendToTable = MODULE + '/' + appendToTable;
const addAvailable = 'addAvailable';
export const doAddAvailable = MODULE + '/' + addAvailable;
const removeAvailable = 'removeAvailable';
export const doRemoveAvailable = MODULE + '/' + removeAvailable;
const applyFor = 'applyFor';
export const doApplyFor = MODULE + '/' + applyFor;
const removeApply = 'removeApply';
export const doRemoveApply = MODULE + '/' + removeApply;
const acceptApply = 'acceptApply';
export const doAcceptApply = MODULE + '/' + acceptApply;
const removeAccepted = 'removeAccepted';
export const doRemoveAccepted = MODULE + '/' + removeAccepted;


// ----------------- MUTATION TYPES ---------------------------
export const SET_USER_PROFILES = 'SET_USER_PROFILES';
export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const SET_AVAILABLE = 'SET_AVAILABLE';
export const SET_APPLIES = 'SET_APPLIES';
export const ADD_AVAILABLE = 'ADD_AVAILABLE';
export const RESET_LOADING = 'RESET_LOADING';
export const SET_LOADING = 'SET_LOADING';

// ----------------- GETTERS ---------------------------
const getClientActive = 'getClientActive';
export const pfGetClientActive = MODULE + '/' + getClientActive;
const getPartnersAt = 'getPartnersAt';
export const pfGetPartnersAt = MODULE + '/' + getPartnersAt;
const getProfile = 'getProfile';
export const pfGetProfile = MODULE + '/' + getProfile;
const getAvailablesAt = 'getAvailablesAt';
export const pfGetAvailablesAt = MODULE + '/' + getAvailablesAt;
const getIncomingAppliesAt = 'getIncomingAppliesAt';
export const pfGetIncomingAppliesAt = MODULE + '/' + getIncomingAppliesAt;
const getOutgoingAppliesAt = 'getOutgoingAppliesAt';
export const pfGetOutgoingAppliesAt = MODULE + '/' + getOutgoingAppliesAt;


export default {
  namespaced: true,
  // ===================================================== STATE =====================================================
  state: () => ({
    userProfiles: Object.create(null), // key: client+__+subject_type_id => value: Profile object
    availables: [],
    applies: [],
    loadingPartnerIds: {},
  }),
  // ===================================================== ACTIONS =====================================================
  actions: {
    // -------------------------- subscribe: STARTUP --------------------------------
    setStartUpRaw: {
      root: true,
      handler ({ commit }, body) {

        let profiles = Object.create(null);
        if (body.partnerFinderProfiles) {
          for (let p of body.partnerFinderProfiles) {
            profiles[p.client + '__' + p.subject_type_id] = p;
          }
        }
        commit(SET_USER_PROFILES, profiles);
      },
    },

    // -------------------------- subscribe: AFTER FETCH TABLE --------------------------------
    afterFetchTable: {
      root: true,
      // eslint-disable-next-line
      handler ({ commit, dispatch }, body) {
        if (body.hasOwnProperty('partnerFinder') && body.partnerFinder.hasOwnProperty('availables'))
          commit(SET_AVAILABLE, body.partnerFinder.availables);
        else
          commit(SET_AVAILABLE, []);
        if (body.hasOwnProperty('partnerFinder') && body.partnerFinder.hasOwnProperty('applies'))
          commit(SET_APPLIES, body.partnerFinder.applies);
        else
          commit(SET_APPLIES, []);
        commit(RESET_LOADING);
      },
    },

    // -------------------------- APPEND TABLE EXTRAS --------------------------------
    // (fetchTable and socket refres calls this)
    appendTableExtras: {
      root: true,
      // eslint-disable-next-line
      handler ({ commit, dispatch }, body) {
        dispatch(appendToTable);
      },
    },


    // -------------------------- SOCKET AVAILABLE LIST --------------------------------
    socketAvailableList ({ state, rootState, commit, dispatch }, data) {
      console.log('STORE FROM SOCK', rootState.currentSubjectTypeID, rootState.currentTableDate);
      if (rootState.currentSubjectTypeID != data.subject_type_id)
        return;

      let newAvailables = data.availables;


      // ha nem a most kapott tartományon belül van a régi listából valaki, akkor megtartjuk:
      let oldAvailables = state.availables;
      let startDate = moment(data.start_date);
      let endDate = moment(data.end_date);
      for (let old of oldAvailables) {
        let d = moment(old.from_time).startOf('day');
        if (d.isBefore(startDate) || d.isAfter(endDate))
          newAvailables.push(old);
      }
      //console.log('newAvailables', newAvailables)
      commit(SET_AVAILABLE, newAvailables);
      dispatch(appendToTable);
    },


    // -------------------------- SOCKET APPLY LIST --------------------------------
    socketApplyList ({ state, rootState, commit, dispatch }, data) {
      console.log('APPLY FROM SOCK', rootState.currentSubjectTypeID, rootState.currentTableDate);
      if (rootState.currentSubjectTypeID != data.subject_type_id)
        return;

      let newApplies = data.applies;


      // ha nem a most kapott tartományon belül van a régi listából valaki, akkor megtartjuk:
      let oldApplies = state.applies;
      let startDate = moment(data.start_date);
      let endDate = moment(data.end_date);
      for (let old of oldApplies) {
        let d = moment(old.from_time).startOf('day');
        if (d.isBefore(startDate) || d.isAfter(endDate))
          newApplies.push(old);
      }
      //console.log('newAvailables', newAvailables)
      commit(SET_APPLIES, newApplies);

      dispatch(appendToTable);
    },


    // -------------------------- APPEND TO TABLE --------------------------------
    [appendToTable] ({ state, rootGetters, commit }) {
      let avails = state.availables;
      let applies = state.applies;

      applies.forEach(a => {
        a.reserved = false;
      });

      let own_email = rootGetters.getOwnEmail;
      console.log('APPEND-TO-TABLE', own_email);
      let iterator = rootGetters.getTableIterator;

      // round0 : mark reserved appies
      iterator.foreachTimeBlock((tb) => {
        applies.filter(a => a.from_time == tb.startTime && (a.apply_user.email == own_email || a.available_user.email == own_email)).forEach(apply => {
          if ((tb.status == 'reserved' || tb.status == 'own')
            && (tb.ownerEmail == apply.apply_user.email || tb.ownerEmail == apply.available_user.email)) {
            apply.reserved = true;
            if (tb.status == 'reserved') apply.partnerReserved = true;
            else if (tb.status == 'own') apply.ownReserved = true;
          }
        });
      });

      iterator.foreachTimeBlock((tb) => {
        let partnerAvailable = 0;
        let ownAvailable = false;
        tb.partnerIncomings = 0;
        tb.partnerOutgoings = 0;
        //tb.parnter = false;

        avails.filter(a => a.from_time == tb.startTime).forEach(avail => {
          if (avail.user.email == own_email)
            ownAvailable = true;
          else
            partnerAvailable++;
        });

        tb.partnerAvailable = partnerAvailable;
        tb.ownAvailable = ownAvailable;
        tb.acceptedWithoutReserve = false;

        applies.filter(a => a.from_time == tb.startTime && (a.apply_user.email == own_email || a.available_user.email == own_email)).forEach(apply => {

          if (apply.apply_user.email == own_email) {
            if (!apply.reserved)
              tb.partnerOutgoings++;
            if (tb.status == 'reserved' && tb.ownerEmail == apply.available_user.email) {
              tb.partner = true;
            }
            if (tb.status == 'own')
              tb.partner = true;
          }

          if (apply.available_user.email == own_email) {
            if (!apply.reserved)
              tb.partnerIncomings++;
            if (tb.status == 'reserved' && tb.ownerEmail == apply.apply_user.email) {
              tb.partner = true;
            }
            if (tb.status == 'own')
              tb.partner = true;
          }

          if (apply.accepted && !apply.reserved)
            tb.acceptedWithoutReserve = true;
          //apply.reserved = apply.apply_user.email == own_email || apply.
        });
        /*tb.partnerIncomings = applies.filter(a => a.from_time == tb.startTime && a.available_user.email == own_email).length;
        tb.partnerOutgoings = applies.filter(a => a.from_time == tb.startTime && a.apply_user.email == own_email).length;*/
      });

      commit('SET_TABLE', { tables: iterator.tables }, { root: true });
      commit(SET_APPLIES, applies);
    },

    // -------------------------- SAVE PROFILE --------------------------------
    [saveProfile] ({ commit, rootState, dispatch }, data) {
      return api.req(API_GUEST_PARTNER_FINDER_PROFILE_POST, data)
        .then((res) => {
          data.client = rootState.currentClientDomain;
          commit(SET_USER_PROFILE, data);
          if (data.phone) {
            dispatch('setUserPhoneNumber', {
              newPhoneNumber: data.phone,
            }, { root: true });
          }

          return res;
        });
    },

    // -------------------------- ADD AVAILABLE --------------------------------
    // eslint-disable-next-line
    [addAvailable] ({ commit }, data) {
      return api.req(API_GUEST_PARTNER_FINDER_AVAILABLE_POST, data);
    },

    // -------------------------- REMOVE AVAILABLE --------------------------------
    // eslint-disable-next-line
    [removeAvailable] ({ commit }, data) {
      return api.req(API_GUEST_PARTNER_FINDER_AVAILABLE_DELETE, data);
    },

    // -------------------------- APPLY FOR --------------------------------
    [applyFor] ({ commit }, data) {
      console.log('applyfor', data.user_id);
      commit(SET_LOADING, data.user_id);
      return api.req(API_GUEST_PARTNER_FINDER_APPLY_POST, data, {
        finally: () => {
          commit(RESET_LOADING, data.user_id);
        },
      });
    },

    // -------------------------- REMOVE APPLY --------------------------------
    // eslint-disable-next-line
    [removeApply] ({ state, commit }, data) {
      let apply = state.applies.find(a => a.id == data.id);
      if (!apply) {
        notify.warning(`Apply not found (store/${data.id})`);
        return;
      }
      let user_id = apply.available_user.id;
      commit(SET_LOADING, user_id);
      return api.req(API_GUEST_PARTNER_FINDER_APPLY_DELETE, data, {
        finally: () => {
          commit(RESET_LOADING, user_id);
        },
      });
    },

    // -------------------------- ACCEPT APPLY --------------------------------
    // eslint-disable-next-line
    [acceptApply] ({ state, commit }, data) {
      let apply = state.applies.find(a => a.id == data.accepted_partner_apply_id);
      if (!apply) {
        notify.warning(`Apply not found (store/${data.accepted_partner_apply_id})`);
        return;
      }
      let user_id = apply.apply_user.id;
      commit(SET_LOADING, user_id);
      return api.req(API_GUEST_PARTNER_FINDER_ACCEPT_POST, data, {
        finally: () => {
          commit(RESET_LOADING, user_id);
        },
      });
    },

    // -------------------------- REMOVE ACCEPTED --------------------------------
    // eslint-disable-next-line
    [removeAccepted] ({ state, commit, rootGetters }, data) {
      let apply = state.applies.find(a => a.id == data.apply_id);
      if (!apply) {
        notify.warning(`Apply not found (store/${data.apply_id})`);
        return;
      }
      let own_email = rootGetters.getOwnEmail;
      let user_id = apply.apply_user.email == own_email ? apply.available_user.id : apply.apply_user.id;
      commit(SET_LOADING, user_id);
      return api.req(API_GUEST_PARTNER_FINDER_ACCEPTED_DELETE, data, {
        finally: () => {
          commit(RESET_LOADING, user_id);
        },
      });
    },

  },
  // ===================================================== MUTATIONS =====================================================
  mutations: {
    [SET_USER_PROFILES] (state, data) {
      state.userProfiles = data;
    },
    [SET_USER_PROFILE] (state, data) {
      Vue.set(state.userProfiles, data.client + '__' + data.subject_type_id, data);
    },
    [SET_AVAILABLE] (state, rawAvailable) {
      state.availables = rawAvailable;
    },
    [SET_APPLIES] (state, rawApplies) {
      state.applies = rawApplies;
    },
    [ADD_AVAILABLE] (state, available) {
      state.availables.push(available);
    },
    [RESET_LOADING] (state, id) {
      Vue.set(state.loadingPartnerIds, id, false);
    },
    [SET_LOADING] (state, id) {
      Vue.set(state.loadingPartnerIds, id, true);
    },
  }

  // ===================================================== GETTERS =====================================================
  , getters: {

    // eslint-disable-next-line
    [getClientActive]: (state, getters, rootState, rootGetters) => {
      return rootGetters.isLoggedIn && !!(rootGetters.getSelectedClientConfig?.partnerFinder);
    },


    // eslint-disable-next-line
    [getProfile]: (state, getters, rootState) => {
      //console.log('--------------profile-----------------', rootState.currentSubjectTypeID, state.userProfiles)
      return state.userProfiles[rootState.currentSubjectTypeID];
    },
    // eslint-disable-next-line
    [getAvailablesAt]: (state, getters, rootState, rootGetters) => time => {
      let own_email = rootGetters.getOwnEmail;
      console.log('avvvvvv', time);
      return state.availables.filter(a => a.user.email != own_email && a.from_time == time);
    },

    // eslint-disable-next-line
    [getIncomingAppliesAt]: (state, getters, rootState, rootGetters) => time => {
      let own_email = rootGetters.getOwnEmail;
      return state.applies.filter(a => a.available_user.email == own_email && a.from_time == time);
    },

    // eslint-disable-next-line
    [getOutgoingAppliesAt]: (state, getters, rootState, rootGetters) => time => {
      let own_email = rootGetters.getOwnEmail;
      return state.applies.filter(a => a.apply_user.email == own_email && a.from_time == time);
    },

    // eslint-disable-next-line
    [getPartnersAt]: (state, getters, rootState, rootGetters) => time => {
      let own_email = rootGetters.getOwnEmail;
      let partners = new Map();
      let own = {
        available: false,
        accepted: false,
        partnerCount: 0,
      };
      state.applies.filter(a => a.from_time == time).forEach(a => {
        let partner = null;
        let incoming = false;
        if (a.apply_user.email == own_email) {
          partner = a.available_user;
        } else if (a.available_user.email == own_email) {
          partner = a.apply_user;
          incoming = true;
        } else return;

        let p = partners.get(partner.email);
        if (!p) {
          p = { user: partner, applyIncoming: incoming, applyOutgoing: !incoming, available: false };
          partners.set(partner.email, p);
          p.loading = state.loadingPartnerIds[a.available_user.id] || state.loadingPartnerIds[a.apply_user.id];
          console.log('app loading:', p.loading);
        } else {
          if (incoming) p.applyIncoming = true;
          else p.applyOutgoing = true;
        }
        if (incoming)
          p.incomingApplyId = a.id;
        else
          p.outgoingApplyId = a.id;
        if (a.accepted) p.accepted = true;
        if (a.accepted) own.accepted = true;
        if (a.reserved) p.reserved = true;
        if (a.ownReserved) p.ownReserved = true;
        if (a.partnerReserved) p.partnerReserved = true;
      });
      state.availables.filter(a => a.from_time == time).forEach(a => {
        if (a.user.email == own_email) {
          own.available = true;
          return;
        }

        let p = partners.get(a.user.email);
        if (!p) {
          p = { user: a.user, applyIncoming: false, applyOutgoing: false, available: true };
          partners.set(a.user.email, p);
          p.loading = state.loadingPartnerIds[a.user.id];
        } else {
          p.available = true;
        }
      });
      let pa = Array.from(partners.values());
      //for (let i = 0; i < 5; i++)  pa = pa.concat(pa);
      own.partnerCount = pa.filter(p => !p.accepted).length;
      return {
        own,
        partners: pa,
      }
    },

  },
}
